import styles from '../../search.module.scss'
import Icon from '@/components/styleguide/Icon'
import { PerformanceFilterEngineItemProps } from '@/types/search'
import { Size } from '@/types/system'

type MinMaxSelectProps = {
  activeMin: number | undefined
  activeMax: number | undefined
  availableMinimum: PerformanceFilterEngineItemProps[]
  availableMaximum: PerformanceFilterEngineItemProps[]
  handleMaxInput: (value: number) => void
  handleMinInput: (value: number) => void
}

export const MinMaxSelect = ({
  activeMin,
  activeMax,
  availableMaximum,
  availableMinimum,
  handleMinInput,
  handleMaxInput,
}: MinMaxSelectProps) => {
  return (
    <div className={styles.minmax}>
      <div className={styles.selects}>
        <span className={styles.label}>Min</span>
        <div className={styles.select}>
          <select
            className={styles.control}
            id="engine-min"
            title="Engine size minimum"
            onChange={e => handleMinInput(parseInt(e.target.value, 10))}
            value={activeMin || '-1'}>
            <option value="-1">Any</option>
            {availableMinimum
              .filter(
                (item: PerformanceFilterEngineItemProps) =>
                  item.type === 20 && (activeMax ? item.id < activeMax - 9 : item.id <= 53),
              )
              .map((item: PerformanceFilterEngineItemProps) => (
                <option
                  value={item.id}
                  key={item.id}>
                  {item.name}L
                </option>
              ))}
          </select>
          <Icon
            customClass={styles.icon}
            name="ChevronDown"
            size={Size.Medium}
          />
        </div>
      </div>
      <div className={styles.selects}>
        <span className={styles.label}>Max</span>
        <div className={styles.select}>
          <select
            className={styles.control}
            id="engine-max"
            title="Engine size maximum"
            onChange={e => handleMaxInput(parseInt(e.target.value, 10))}
            value={activeMax || '-1'}>
            <option value="-1">Any</option>
            {availableMaximum
              .filter(
                (item: PerformanceFilterEngineItemProps) =>
                  item.type === 21 && (activeMin ? item.id > activeMin + 9 : item.id > 53),
              )
              .map((item: PerformanceFilterEngineItemProps) => (
                <option
                  value={item.id}
                  key={item.id}>
                  {item.name}L
                </option>
              ))}
          </select>
          <Icon
            customClass={styles.icon}
            name="ChevronDown"
            size={Size.Medium}
          />
        </div>
      </div>
    </div>
  )
}
